export default __webpack_public_path__ + "06f437968bc69d92dd677885e81fd909.png";